
import json5 from 'json5';

export const convertBody = (body: string) => {
    try {
        let parsedBody = body.replace('```json', '').replace('```', '');
        parsedBody = json5.parse(parsedBody);
        return parsedBody as unknown as object[];
    } catch (error) {
        try {
            const fixedJson = jsonFixer(body);
            return json5.parse(fixedJson);
        } catch (error) {
            console.error('Error occured When parsing translated error: ', error);
            console.error('Error occured When parsing translated body ', body);
            throw new Error(
                `Openapi translate with assistant An error occurred while processing your request .error: ${error} body: ${body}`,
            );
        }
    }
}

export const jsonFixer = (json: string, provider?: string) => {
    if (provider === 'bedrock') {
        json += '}';
    }
    let fixedText = json
        .replace('```json', '')
        .replace('```', '')
        .replace(/”/g, '"')
        .replace(/“/g, '"')
        .replace(/’/g, "'")
        .replace(/‘/g, "'");

    const regex = /"text":\s*"([^]*)"/g;

    // Metinde her text alanını kontrol et
    fixedText = fixedText.replace(regex, (match, p1) => {
        let text = p1.trim();

        if (!text.startsWith('"')) {
            text = '"' + text;
        }

        if (!text.endsWith('"')) {
            text = text + '"';
        }

        return `"text": ${text}`;
    });

    return fixedText;
};

export const formatCompletion = (completion: string) => {
    const translatedText = completion
        .trim()
        .replace(/<translated_text>/g, '')
        .replace('</translated_text>', '');
    const body = convertBody(translatedText)
    return body
}

export const checkJsonCompletion = (completion: string) => {
    return completion.includes("```json") || completion.includes("\"type\":") || completion.includes("\"content\":")
}